import React from "react";
import Collapsible from "react-collapsible";

import "./accordion.styles.css";

const Accordion = ({
  children,
  title,
}: {
  title: string;
  children: React.ReactNode | string;
}) => {
  return (
    <Collapsible
      trigger={title}
      transitionTime={100}
      open
      overflowWhenOpen="auto"
    >
      <div className="app-collapsible-children">{children}</div>
    </Collapsible>
  );
};

export default Accordion;
